export const formatReceiptStatus = (status?: string) => {
  switch (status) {
    case 'submitted':
      return '\u5df2\u63d0\u4ea4'
    case 'cashier_done':
      return '\u5df2\u51fa\u7eb3'
    case 'accounted':
      return '\u5df2\u505a\u8d26'
    case 'completed':
      return '\u5df2\u5b8c\u6210'
    default:
      return status || '-'
  }
}

export const getInconsistencyLabel = (type: string) => {
  switch (type) {
    case 'vehicle_accounting_mismatch':
      return '\u8f66\u8f86\u7ba1\u7406\u5458\u4e0e\u4f1a\u8ba1\u5458\u4e0d\u4e00\u81f4'
    case 'vehicle_accounting_pending':
      return '\u4f1a\u8ba1\u5f85\u505a\u8d26'
    case 'accounting_cashier_mismatch':
      return '\u4f1a\u8ba1\u5458\u4e0e\u51fa\u7eb3\u5458\u4e0d\u4e00\u81f4'
    case 'overdue_vehicles':
      return '\u903e\u671f\u8f66\u8f86'
    default:
      return '\u5176\u4ed6\u5f02\u5e38'
  }
}

export const getReceiptMismatchLabel = (type: string) => {
  switch (type) {
    case 'receipt_item_total_mismatch':
      return '\u6536\u636e\u91d1\u989d\u4e0e\u660e\u7ec6\u5408\u8ba1\u4e0d\u4e00\u81f4'
    case 'missing_cashier_signature':
      return '\u6536\u636e\u7f3a\u5c11\u51fa\u7eb3\u7b7e\u540d'
    case 'missing_charge_range':
      return '\u660e\u7ec6\u7f3a\u5c11\u6263\u6b3e\u8303\u56f4'
    case 'voucher_not_balanced':
      return '\u8bb0\u8d26\u51ed\u8bc1\u501f\u8d37\u4e0d\u5e73\u8861'
    case 'voucher_receipt_amount_mismatch':
      return '\u51ed\u8bc1\u91d1\u989d\u4e0e\u6536\u636e\u4e0d\u4e00\u81f4'
    default:
      return '\u5176\u4ed6\u5f02\u5e38'
  }
}
